import React, { useCallback, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useSnackbar } from 'notistack';
import { DictionaryDto, useDictionaryApi } from '../../api/dictionary';
import { fetchRegionsDict } from '../../api/regions';
import { CourierCoord, CourierDetailsDto, fetchCourierCoords } from '../../api/couriers';

const useStyles = makeStyles((theme) => ({
    mapWrapper: {
        height: '90%',
    },
    mapContainer: {
        width: '100%',
        minHeight: '400px',
        height: '100%',
        border: '1px solid #ccc',
    },
    formControl: {
        minWidth: 200,
        marginBottom: theme.spacing(1),
    },
}));

const { ymaps } = window as any;
let myMap: any;
let myCollection: any;

const CouriersMap = () => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [regions, setRegions] = useState<DictionaryDto[]>([]);
    const [loadMap, setLoadMap] = useState<boolean>(false);
    const [regionId, setRegionId] = useState<string | number>('');
    const [courierCoords, setCourierCoords] = useState<CourierCoord[]>([]);
    const { getById: getCourierById } = useDictionaryApi<CourierDetailsDto>('/courier/detail');
    const [open, setOpen] = useState(false);
    const handleClose = () => {
        setOpen(false);
    };

    const handleLoad = useCallback(() => {
        setLoadMap(false);

        ymaps.ready(() => {
            myMap = new ymaps.Map(
                'map',
                {
                    center: [51.128207, 71.430411],
                    zoom: 11,
                },
                {
                    balloonMaxWidth: 200,
                    searchControlProvider: 'yandex#search',
                }
            );

            myCollection = new ymaps.GeoObjectCollection();
        });
    }, []);

    const handleChangeRegion = (e: any) => {
        setRegionId(e.target.value);
    };

    useEffect(() => {
        fetchRegionsDict().then((res) => {
            setRegions(res);
            if (res.length > 0) {
                setRegionId(res[0].id);
            }

            setLoadMap(true);
        });
    }, []);

    useEffect(() => {
        if (loadMap) {
            handleLoad();
        }
    }, [handleLoad, loadMap]);

    useEffect(() => {
        if (!regionId) {
            setCourierCoords([]);
            return;
        }

        fetchCourierCoords(regionId).then((res) => {
            setCourierCoords(res);
            const first = res.find((r: CourierCoord) => r.latitude && r.longitude);
            if (first) {
                myMap.setCenter([first.latitude, first.longitude]);
            } else {
                setOpen(true);
                setCourierCoords([]);
            }
        });
    }, [regionId]);

    useEffect(() => {
        if (myCollection) {
            myCollection.removeAll();
        }


        if (myMap) {
            myMap.geoObjects.add(myCollection);
        }
    }, [courierCoords, enqueueSnackbar, getCourierById]);

    return (
        <Box width="100%" height="100%">
            <Box>
                <FormControl className={classes.formControl}>
                    <InputLabel id="region">Регион</InputLabel>
                    <Select
                        labelId="region"
                        id="region-select"
                        value={regionId}
                        onChange={handleChangeRegion}
                    >
                        {regions.map((region) => (
                            <MenuItem key={region.id} value={region.id}>
                                {region.description}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>

            <Box className={classes.mapWrapper}>
                <div id="map" className={classes.mapContainer}></div>
            </Box>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        На выбранном регионе курьеров на карте отсутствует
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default CouriersMap;
